import { useNavigate, useParams } from "react-router-dom";
import CannedNotesForm from "./CannedNotesForm";
import { useGetCannedNoteByIdQuery } from "./cannedNotesApi";
import { useEffect, useState } from "react";
import Preloader from "../../../components/common/Preloader";
import { hasPermission } from "../../../helpers/utils/AccessControlUtils";


const UpdateCannedNote = () => {
    let { noteId } = useParams();

    const cannedNoteApi = useGetCannedNoteByIdQuery(noteId);
    const [crumbs, setCrumbs] = useState<any[]>([]);


    useEffect(() => {
        let obj = cannedNoteApi?.data;
        if (obj) {
            setCrumbs([
                { content: "Home", url: "/home" },
                { content: "Canned Notes", url: "/canned-notes" },
                { content: `${obj?.noteNumber}`, url: "" }
            ]);


        }
    }, [cannedNoteApi]);

    return (
        <>
            {cannedNoteApi.data === undefined || cannedNoteApi?.data?.id === undefined
                ? <Preloader />
                :
                <CannedNotesForm crumbs={crumbs} title={"Update Canned Note"} btnText={"Update"}
                    isReadOnly={hasPermission(["CANNOTE-U"]) === false} />
            }
        </>

    )
}

export default UpdateCannedNote;